import styles from "./index.module.css";
import { useEffect, useRef } from "react";
import BuyCard from "../../buyCard";
import VideoAlert from "../../../video-alert";
import PreAndNext from "../../preAndNext";
import Cast from "../../cast";
import LazyLoad from "react-lazyload";
const MisalignedDetail = ({
  isMobile,
  handleNextIndex,
  handleLastIndex,
  playVideo,
  pauseVideo,
  movieData,
}) => {
  useEffect(() => {
    new VideoAlert(
      {
        havePathElement: `.${styles.btsPlayButton}`,
        openAlert: pauseVideo,
      },
      []
    );
  });
  return (
    <div className={styles.ctn}>
      <div className={styles.movieInfo}>
        <div className={styles.movieNameBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-1.jpg"
            alt=""
            className={styles.movieName}
          />
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-2.jpg"
            alt=""
            className={styles.btsPlayButton}
            data-cursor-size="80px"
            data-video-src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-bts-04.mp4"
          />
        </div>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-3${
            isMobile ? "-m" : ""
          }.jpg`}
          alt=""
          className={styles.author}
        />
      </div>
      <div>
        <LazyLoad offset={300}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-4.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-4-cover.jpg"
            className={styles.abMedia1}
          ></video>
        </LazyLoad>

        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-5.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-5-cover.jpg"
            className={styles.abMedia2}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-6${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-7.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-7-cover.jpg"
            className={styles.abMedia3}
          ></video>
        </LazyLoad>

        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-8.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-8-cover.jpg"
            className={styles.abMedia4}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-9${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-10.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-10-cover.jpg"
            className={styles.abMedia5}
          ></video>
        </LazyLoad>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-11.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-11-cover.jpg"
            className={styles.abMedia6}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-12${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-13.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-13-cover.jpg"
            className={styles.abMedia7}
          ></video>
        </LazyLoad>
        <LazyLoad offset={300}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-14.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-14-cover.jpg"
            className={styles.abMedia8}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-15${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300} className={styles.abMedia9}>
          {" "}
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-16.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-16-cover.jpg"
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-4-17${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>
      <Cast
        movieName={movieData.name}
        data={[
          {
            post: "PRODUCER",
            name: "TRIO STORIES",
          },
          {
            post: "DIRECTOR",
            name: "SALLY-ANN DUNN",
          },
          {
            post: "CINEMATOGRAPHER",
            name: "BARTOSZ WOZNIAK, KACPER WOZNIAK, SALLY-ANN DUNN",
          },
          {
            post: "LEAD ACTOR",
            name: "DARIUSZ CZARNIECKI",
          },
          {
            post: "EXTRAS",
            name: "ANASTASIA WINIARSKA, MARTA JÓŹWIAK, AGATA GRABOWSKA",
          },
          {
            post: "BEHIND THE SCENES",
            name: "KACPER WOZNIAK",
          },
          {
            post: "ORIGINAL MUSIC",
            name: "BARTOSZ GRUCHALA",
          },
          {
            post: "SPECIAL THANKS",
            name: "LUIS MEXICANTINA, LUKSFERA STUDIO, MARIUSZ DOROZKO, FORMATT HITECH",
          },
        ]}
      />
    </div>
  );
};

export default MisalignedDetail;
